const SoftwareOptionsFormNames = {
	GeneralForm: "SoftwareOptionsGeneralForm",
	FileBuildOnlyForm: "SoftwareOptionsFileBuildOnlyForm",
	TerminalForm: "SoftwareOptionsTerminalForm",
	GatewayForm: "SoftwareOptionsGatewayForm",
	PointOfSaleForm: "SoftwareOptionsPointOfSaleForm",
	BillingInfoForm: "SoftwareOptionsBillingInfoForm",
	TerminalArraySection: "TERMINAL_ARRAY_SECTION",
};

export { SoftwareOptionsFormNames };
